import React from 'react';
import { useGetHasEntitlement } from './useGetHasEntitlement.hook';
import { EntitlementType } from '../@types/entitlement';
import { useGetProductsStatus } from '../apiHooks/productsStatus.hook';
import { DEPOSIT_SERVICE_STATUS } from '../@types/deposit';

export const useGetCanVisitDeposit = () => {
  const { productsStatus } = useGetProductsStatus();
  const depositStatus = productsStatus?.deposit?.status;
  const isEntitledForDeposit = useGetHasEntitlement(EntitlementType.DEPOSIT_SERVICE);

  const canVisitDeposit = React.useMemo(() => {
    return (
      !!depositStatus &&
      ![
        DEPOSIT_SERVICE_STATUS.NOT_ACTIVATED,
        DEPOSIT_SERVICE_STATUS.CANCELLED,
        DEPOSIT_SERVICE_STATUS.PRE_PENDING,
      ].includes(depositStatus) &&
      isEntitledForDeposit
    );
  }, [depositStatus, isEntitledForDeposit]);

  return canVisitDeposit;
};
